import React from 'react';

// DEPENDENCIES
import pick from 'lodash/pick';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// CORE COMPONENTS
import Form from 'core/form/Form';

// PARTS
import Card from 'parts/card/Card';
import Record from 'parts/record/Record.js';

// VARIABLES
const INITIAL_VALUES = {
  is_active: 1
}

// FUNCTIONS
const formatRecord = record => pick(record, [
  'is_active',
  'report_category_id',
  'report_category_name'
])

// MAIN COMPONENT
const ReportCategoryUpdate = () => (
  <Record.Update
    recordLabel="report category"
    endpoints={ENDPOINTS.admin.reports.category}
    initialValues={INITIAL_VALUES}
    formatRecord={formatRecord}
    deleteButton={false}
  >
    <Card body={<FormBody />} />
  </Record.Update>
);

const FormBody = () => (
  <Form.Body>
    <Form.YesNo name="is_active" label="Active" required />
    <Form.Control name="report_category_name" label="Category Name" required />
    <Record.Log />
  </Form.Body>
);

// EXPORT
export default ReportCategoryUpdate;
